import moment from 'moment';

export const isoDateFormat = isoDate => moment(isoDate).format('LL');



// WEBPACK FOOTER //
// ./src/util/DateFormat.js